<template>
  <div style="max-width: 900px">
    <ValidationObserver ref="form">
      <form>

        <div class="form-group row">
          <label class="col-sm-3"><span/>社員ID <span class="require" v-if="formDataValidate.Id" >*</span></label>
          <div class="col-sm-9">
            <validation-provider :rules="formDataValidate.Id" v-slot="{ errors }" name="社員ID">
              <input type="text" class="form-control" placeholder="" v-model="formData.Id" >
              <span>{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-3"><span/>EName <span class="require" v-if="formDataValidate.Ename" >*</span></label>
          <div class="col-sm-9">
            <validation-provider :rules="formDataValidate.Ename" v-slot="{ errors }" name="Member Name">
              <input type="text" class="form-control" placeholder="" v-model="formData.Ename" >
              <span>{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-3"><span/>分區 <span class="require" v-if="formDataValidate.Area" >*</span></label>
          <div class="col-sm-9">
            <validation-provider :rules="formDataValidate.Area" v-slot="{ errors }" name="分區">
              <input type="text" class="form-control" placeholder="" v-model="formData.Area" >
              <span>{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-3"><span/>姓名 <span class="require" v-if="formDataValidate.Name" >*</span></label>
          <div class="col-sm-9">
            <validation-provider :rules="formDataValidate.Name" v-slot="{ errors }" name="姓名">
              <input type="text" class="form-control" placeholder="" v-model="formData.Name" >
              <span>{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-3"><span/>扶輪職稱 <span class="require" v-if="formDataValidate.Position" >*</span></label>
          <div class="col-sm-9">
            <validation-provider :rules="formDataValidate.Position" v-slot="{ errors }" name="扶輪職稱">
              <input type="text" class="form-control" placeholder="" v-model="formData.Position" >
              <span>{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-3"><span/>Call name <span class="require" v-if="formDataValidate.CallName" >*</span></label>
          <div class="col-sm-9">
            <validation-provider :rules="formDataValidate.CallName" v-slot="{ errors }" name="Call name">
              <input type="text" class="form-control" placeholder="" v-model="formData.CallName" >
              <span>{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-3"><span/>所屬社 <span class="require" v-if="formDataValidate.Group" >*</span></label>
          <div class="col-sm-9">
            <validation-provider :rules="formDataValidate.Group" v-slot="{ errors }" name="所屬社">
              <input type="text" class="form-control" placeholder="" v-model="formData.Group" >
              <span>{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-3"><span/>行動電話 <span class="require" v-if="formDataValidate.Tel" >*</span></label>
          <div class="col-sm-9">
            <validation-provider :rules="formDataValidate.Tel" v-slot="{ errors }" name="行動電話">
              <input type="text" class="form-control" placeholder="" v-model="formData.Tel" >
              <span>{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-3"><span/>桌號 <span class="require" v-if="formDataValidate.TableNo" >*</span></label>
          <div class="col-sm-9">
            <validation-provider :rules="formDataValidate.TableNo" v-slot="{ errors }" name="桌號">
              <input type="text" class="form-control" placeholder="" v-model="formData.TableNo" >
              <span>{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-3"><span/>車號 <span class="require" v-if="formDataValidate.CarNo" >*</span></label>
          <div class="col-sm-9">
            <validation-provider :rules="formDataValidate.CarNo" v-slot="{ errors }" name="行動電話">
              <input type="text" class="form-control" placeholder="" v-model="formData.CarNo" >
              <span>{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-3"><span/>Memo <span class="require" v-if="formDataValidate.Memo" >*</span></label>
          <div class="col-sm-9">
            <validation-provider :rules="formDataValidate.Memo" v-slot="{ errors }" name="Memo">
              <textarea class="form-control" rows="3" v-model="formData.Memo"></textarea>
              <span>{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>

        <h1 v-if="this.SystemId">參加場次</h1>

        <div class="form-group row" v-if="this.SystemId">
          <UIEventItemsForMemberEdit ref="uiEventItems" :member="formData"  :event-system-id="EventSystemId" v-if="isLoadFormData"></UIEventItemsForMemberEdit>

        </div>


        <div class="form-group row">
          <div class="col-sm-10">
            <a class="btn btn-primary mybutton" @click.prevent="submit">確定</a>
<!--            <a class="btn btn-primary mybutton" @click.prevent="clone">複製到下一筆功能</a>-->
            <a class="btn btn-danger mybutton" @click.prevent="reset">取消</a>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>/**

 **/
import util from "@/util/util";
import apiAdmin from "@/views/taylorAdmin/js/apiAdmin";
import apiCheckIn from "@/views/checkInAdmin/js/apiCheckIn";
import veeHelper from "@/util/veeHelper";
import {CheckIn_EventItemType_Open,CheckIn_EventItemType_NeedReg,QueryType_CheckIn_Index_3_EventMemberJoinInfo} from "@/views/checkInAdmin/js/checkInDeclare";
import UIEventItemsForMemberEdit from "@/views/checkInAdmin/Event/UIEventItemsForMemberEdit";

let returnRouter="CheckInAdminEventMemberListEdit";

export default {
  components: {UIEventItemsForMemberEdit},
  data: function () {
    return {
      CheckIn_EventItemType_Open:CheckIn_EventItemType_Open,
      CheckIn_EventItemType_NeedReg:CheckIn_EventItemType_NeedReg,
      QueryType_CheckIn_Index_3_EventMemberJoinInfo:QueryType_CheckIn_Index_3_EventMemberJoinInfo,
      EventSystemId: "",
      SystemId: "",
      type: "",
      eventData:{

      },
      formData: {
        UUID: "",
        Id: "",
        Ename: "",
        Area: "",
        Name: "",
        Position: "",
        CallName: "",
        Group: "",
        Tel: "",
        Memo:"",
      },
      eventJoinInfo:[],
      eventJoinInfoDemo:[
        {
          EventSystemId:"",
          IsReged:false,
          IsCheckIn:false,
          Field01:"",
          Field02:"",
          Field03:"",
        }
      ],
      formDataValidate: {
        Id: "required",
        Ename: "",
        Area: "",
        Name: "required",
        Position: "",
        CallName: "",
        Group: "",
        Tel: "",
        Memo:"",
        TableNo:"",
        CarNo:"",
      },
      isLoadFormData:false,
    };
  },
  watch:{
    '$route'(to,from){// eslint-disable-line
      this.SystemId=this.$route.query.SystemId
      this.type=this.$route.query.type

      this.getItem()
      this.$forceUpdate();
    },
  },
  methods: {
    getItem:function(){
      let that=this

      let loader=util.ShowLoading(this);

      if (this.SystemId){

        apiCheckIn.api_Member_Get(this.SystemId).then((data)=>{
          that.formData=apiAdmin.initReturnObjectWithTemplate(data.data.data,that.formData);

          that.isLoadFormData=true;
          util.HideLoading(loader);
        });


      }else{
        util.HideLoading(loader);
      }



      // apiAdmin.api_getContentBySystemId(this.EventSystemId).then((data)=>{
      //   that.eventData=apiAdmin.initReturnObjectWithTemplate(data.data.data,this.eventData);
      // });
      //
      // apiAdmin.api_getContent(QueryType_CheckIn_Index_3_EventMemberJoinInfo+ "_" + this.SystemId).then((data)=>{
      //   that.eventJoinInfo=apiAdmin.init(data.data.data);
      // })

    },
    submit:function(){
      let that=this
      let router=this.$router


      this.$refs.form.validateWithInfo().then(({ isValid, errors }) => {
        if (!isValid) {
          let errorMsg=veeHelper.VeeGetErrorMsgAllStr(errors);
          util.ShowMessage('部分資料未填寫完整'  +"<br/>" +errorMsg)
          return;
        }else{

          //---------------------------------------
          // apiAdmin.api_saveContentBySystemId(that.type,that.SystemId,that.formData).then(()=>{
          //
          //   apiAdmin.api_saveContent(QueryType_CheckIn_Index_3_EventMemberJoinInfo+ "_" + that.SystemId,that.eventJoinInfo).then(()=>{
          //     util.ShowMessage('儲存成功')
          //     router.push({ name: returnRouter, query: { type: that.type,SystemId:this.EventSystemId }})
          //   })
          // })

          let memberEventItemsDataForSave =[];

          if (this.SystemId){
            memberEventItemsDataForSave=this.$refs.uiEventItems.getMemberEventItemsDataForSave();
          }

          that.formData.EventItems=[];

          apiCheckIn.api_MemberJoin_Entity_SyncMember(that.SystemId,memberEventItemsDataForSave).then(()=>{
            apiCheckIn.api_Member_Save(that.SystemId,that.EventSystemId, that.formData).then(()=>{
              util.ShowMessage('儲存成功')
              router.push({ name: returnRouter, query: { type: that.type,SystemId:this.EventSystemId }})
            })
          });

          //---------------------------------------
          // Wait until the models are updated in the UI
          that.$nextTick(() => {
            that.$refs.form.reset();
          });
        }
      });

    },
    reset:function(){
      this.$router.push({ name: returnRouter, query: { type: this.type ,SystemId:this.EventSystemId }})
    },
  },
  mounted() {
    this.SystemId=this.$route.query.SystemId
    this.EventSystemId=this.$route.query.EventSystemId
    this.type=this.$route.query.type

    this.getItem()
  },
}
</script>

<style scoped>

</style>
